<template>
  <div class="modal-metaco">
    <span class="email-metaco-label">
      {{
        $t(
          '_web_auth_provide_username_metaco',
          'Please provide your Metaco email'
        )
      }}
    </span>
    <form @submit.prevent="handleSubmit">
      <div class="email-form-metaco m-0">
        <div
          class="w-100"
          :class="{ 'is-invalid': showError && !isEmailValid }"
        >
          <input
            v-model="email"
            type="email"
            class="new-email-input-modal"
            :placeholder="'email@email.com'"
            :aria-describedby="showError && !isEmailValid ? 'emailHelp' : null"
            @input="updateValue"
            @blur="onBlur"
            @focus="onFocus"
          />
        </div>
        <span
          v-if="showError && !isEmailValid"
          id="emailHelp"
          class="text-danger errors-new"
          aria-live="assertive"
        >
          {{ error }}
        </span>
      </div>
      <button :disabled="!email.trim().length" class="btn-metaco-send">
        {{ $t('_web_auth_metaco_send', 'send') }}
      </button>
      <ModalBackdrop v-model="isLoading" class="verify-code-loader">
        <Loader />
      </ModalBackdrop>
    </form>
  </div>
</template>

<script>
// import HeraFormBtn from '@/components/atoms/HeraFormBtn.vue';
import { mapActions } from 'vuex';
import isLoadingMixin from '@/mixins/isLoading.js';
import { translate } from '@/mixins/translate';
import Loader from '@/components/common/Loader';
import ModalBackdrop from '@/components/common/ModalBackdrop';

export default {
  name: 'MetacoEmailModal',
  components: { ModalBackdrop, Loader },
  inject: ['$validator'],
  mixins: [isLoadingMixin, translate('_web_signup')],

  data() {
    return {
      email: '',
      isEmailValid: true,
      showError: false,
      error: '',
    };
  },
  methods: {
    ...mapActions([
      'sendMetacoCode',
      'getCredentials',
      'snsAuthRequest',
      'collectEmails',
      'closeModal',
      'errorNotify',
    ]),
    updateValue() {
      this.showError = false;
      this.validateEmail(this.email);
    },
    onFocus() {
      this.showError = false;
    },
    onBlur() {
      this.validateEmail(this.email);
      this.showError = true;
    },
    validateEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.isEmailValid = emailPattern.test(email);
      this.error = !this.isEmailValid
        ? 'Please enter a valid email address.'
        : '';
    },
    handleSubmit() {
      this.validateEmail(this.email);
      this.setLoading();
      if (this.isEmailValid) {
        this.sendMetacoCode({ email: this.email })
          .then(res => {
            if (res.code === 404) {
              this.unsetLoading();
              this.errorNotify({
                message: this.$t(
                  '_web_form_metaco_user_not_found',
                  'User is not found in Metaco'
                ),
                inModal: true,
                yesText: this.$t('_web_form_error_confirm-yes', 'OK'),
              });
              this.email = '';
              return;
            }

            if (res.code === 403) {
              this.unsetLoading();
              this.errorNotify({
                message: this.$t(
                  '_web_form_metaco_verify-first',
                  'Your account is unverified. Please verify first on metaco.gg'
                ),
                inModal: true,
                yesText: this.$t('_web_form_error_confirm-yes', 'OK'),
              });
              return;
            }
            if (res.code === 400) {
              this.unsetLoading();
              this.errorNotify({
                message: this.$t(
                  '_web_form_metaco_valid_email',
                  'Please provide valid email'
                ),
                inModal: true,
                yesText: this.$t('_web_form_error_confirm-yes', 'OK'),
              });
              return;
            }
            if (res.code === 200) {
              this.unsetLoading();
              this.getCredentials(this.email)
                .then(() => {
                  this.$router.push({
                    name: 'verifyCode',
                    params: {
                      networkType: 'metaco',
                      email: this.email,
                      provider: 'metaco',
                      from: 'signin',
                      expiration: res.data.expirationTime,
                    },
                  });
                })
                .catch(err => {
                  if (err.status === 404) {
                    this.$router.push({
                      name: 'snsSignup',
                      query: { email: this.email, provider: 'metaco' },
                      params: {
                        networkType: 'metaco',
                        email: this.email,
                        provider: 'metaco',
                        expiration: res.data.expirationTime,
                      },
                    });
                  }
                })
                .finally(() => {
                  this.unsetLoading();
                  this.closeModal();
                  window.dataLayer.push({
                    event: 'metaco sso',
                    email: this.email,
                  });
                });
            }
          })
          .catch(err => {
            this.unsetLoading();
            this.errorNotify({
              message: this.$t(err.message),
              inModal: true,
              yesText: this.$t('_web_form_error_confirm-yes', 'OK'),
            });
          });

        this.error = '';
        this.showError = false;
      } else {
        this.showError = true;
        console.log('Email validation failed');
      }
    },
  },
};
</script>

<style lang="scss">
.error {
  color: #ffcccc; /* Light red color */
  font-size: 0.9em;
}
.modal-metaco {
}
.email-metaco-label {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  color: rgba(255, 255, 255, 0.5) !important;
  font-family: 'Alexandria' !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 24px !important; /* 171.429% */
}
.btn-metaco-send {
  background-color: #5a58f2;
  color: White;
  font-family: 'Alexandria';
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 24px;
  padding: 5px;
  margin-top: 20px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: center;
  &:disabled {
    background-color: #5a58f2;
    opacity: 0.6;
    cursor: not-allowed;
  }
}
.email-form-metaco {
  min-height: 70px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: 'Alexandria', sans-serif !important;
  width: 100%;
  > div {
    > .new-email-input-modal {
      display: flex;
      padding: 10px 12px 10px 16px;
      align-items: flex-start;
      gap: 10px;
      width: 100%;
      align-self: stretch;
      border-radius: 6px;
      border: 1px solid rgba(255, 255, 255, 0.06);
      background: rgba(255, 255, 255, 0.04);
      box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.04) inset;
      backdrop-filter: blur(2px);
      color: white;
      text-decoration: none;

      > input::placeholder {
        color: var(--opacity-800, rgba(255, 255, 255, 0.9));
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px; /* 150% */
      }
    }
  }
}
</style>

<style lang="scss" scoped></style>
